import Vue from "vue";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import BootstrapVue from "bootstrap-vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
import VCalendar from 'v-calendar';
import globals from "./globals";
import Popper from "popper.js";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import lodash from 'lodash';
import "@/contrast-style.css";
import { getCompanyNameFromConfig, captchaKey } from '@/utils/appSettings'


import Notifications from "vue-notification";
import { ClientTable } from "vue-tables-2";

import { vueTableOptions } from "@/utils/helpers";
import VueFormWizard from "vue-form-wizard";

import VueLodash from "vue-lodash";
import "@/utils/logger";

Vue.use(VueLodash, { lodash });
Vue.use(ClientTable, vueTableOptions);
Vue.use(Notifications);
Vue.use(VCalendar, {
    componentPrefix: 'vc'
});
// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;
Vue.config.productionTip = false;
Vue.use(VueFormWizard);
Vue.use(BootstrapVue);

Vue.use(VueReCaptcha, { siteKey: captchaKey() });



// Global RTL flag
Vue.mixin({
    data: globals
});


import translations from "@/translations";
Vue.use(translations);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount("#app");